import { Component, OnInit } from '@angular/core';
import { COUNTRY, LANGS, LANGUAGE } from '@app/shared/types/enums';
import { TranslateService } from '@ngx-translate/core';
import { AppContext } from '@app/shared/services/context/app.context.service';

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.sass'],
})
export class LanguageSelectComponent implements OnInit {
  selectedLanguage: LANGUAGE = 'ES';
  private readonly LANGUAGE_KEY = 'LANGUAGE';
  isActiveSelected: boolean = false

  constructor(private readonly _appCtxSvc: AppContext, private readonly _trsSvc: TranslateService) {}

  ngOnInit(): void {
    this._appCtxSvc.countrySubject$.subscribe(valor => {
      if (valor === COUNTRY.CO) {
        this.isActiveSelected = true
        this.selectedLanguage = LANGS.ES
        this.setLanguage(LANGS.ES)
      } else {
        this.isActiveSelected = false;
        this.selectedLanguage = (localStorage.getItem(this.LANGUAGE_KEY) as LANGUAGE) || LANGS.ES;
        this.setLanguage(this.selectedLanguage);
      }
    })
    //EVOLUTION
    //this.selectedLanguage = this._usrCtxSvc.context?.defaultLocale.split('-')[0] || 'es';
  }

  onLanguageChanged(): void {
    console.log(this.selectedLanguage);
    
    this.setLanguage(this.selectedLanguage);
  }

  private setLanguage(lang: LANGUAGE) {
    localStorage.setItem(this.LANGUAGE_KEY, lang);
    this._trsSvc.use(lang.toLowerCase());
    this._appCtxSvc.setLanguage(lang);
  }
}
